import type { DataContainer, Feature, FeatureStatus } from "@otto-ec/tracking-bct";
import { createLogger } from "utils/logging";

export interface TrackingDataset {
	readonly id: string;
	readonly name: string;
	readonly labels: Record<string, string[]>;
	readonly position?: number;
}

const log = createLogger("cinema", "tracking");

export function buildTrackingPayloadCinema(status: FeatureStatus, cinemaDom: HTMLElement, featurePosition: number, parentId: string, additionalFeatures?: DataContainer): Feature | undefined {
	const cinemaTrackingData = cinemaDom.dataset.cinemaTracking;

	if (!cinemaTrackingData) return undefined;

	let labels: DataContainer = JSON.parse(cinemaTrackingData) as DataContainer;
	if (additionalFeatures) {
		labels = { ...labels, ...additionalFeatures };
	}
	log.info("cinema tracking:", cinemaTrackingData);
	return {
		id: parentId,
		name: "BenefitCinema",
		status,
		position: featurePosition,
		labels,
	};
}

export function buildTrackingPayloadBenefit(
	status: FeatureStatus,
	benefitDom: HTMLElement,
	parentId: string,
):
	| (
		& Feature
		& NonNullable<{
			labels: Record<string, string[]>;
		}>
	)
	| undefined {
	const benefitTrackingData = benefitDom.dataset.tracking;

	if (!benefitTrackingData) return undefined;

	const tracking: TrackingDataset = JSON.parse(benefitTrackingData) as TrackingDataset;
	const position = tracking.position;

	const id = `${parentId}-${tracking.id}${tracking.position}`;

	log.info("benefit tracking:", benefitTrackingData);
	return {
		id,
		name: tracking.name,
		status,
		position,
		labels: tracking.labels,
		parentId,
	};
}
